import { Component, ElementRef, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

import flatpickr from "flatpickr";

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent extends FieldType<FieldTypeConfig> {

  @ViewChild('calendarInput', { static: true }) calendarInput!: ElementRef;

  ngAfterViewInit(): void {
    const slInputEl = this.calendarInput.nativeElement as HTMLElement;

    // Wait for Shoelace to finish rendering its shadow DOM
    requestAnimationFrame(() => {
      const nativeInput = slInputEl.shadowRoot?.querySelector('input');
      if (!nativeInput) {
        console.error('Could not find internal input inside sl-input.');
        return;
      }

      // Make input truly readonly
      nativeInput.setAttribute('readonly', 'true');
      nativeInput.addEventListener('keydown', e => e.preventDefault());

      // Attach Flatpickr to the internal input
      flatpickr(nativeInput, {
        dateFormat: 'm/d/Y',
        defaultDate: this.formControl.value || null,
        allowInput: false,
        clickOpens: true,
        onChange: (selectedDates, dateStr) => {
          this.formControl.setValue(selectedDates.length ? dateStr : null);
        },
        onClose: (selectedDates, dateStr, instance) => {
          const parsed = instance.parseDate(dateStr, 'm/d/Y');
          if (!parsed) {
            instance.clear();
            this.formControl.setValue(null);
          }
        },
      });
    });
  }
}
